import { render, staticRenderFns } from "./sameAnalysis.vue?vue&type=template&id=c683f13a&scoped=true&"
import script from "./sameAnalysis.vue?vue&type=script&lang=js&"
export * from "./sameAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./sameAnalysis.vue?vue&type=style&index=0&id=c683f13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c683f13a",
  null
  
)

export default component.exports